import { StepOverview } from "./views/UpcomingSteps/JourneyStepRow";

export const pendingPreconditionCount = (step: StepOverview) => {
  const pendingPreconditions = step.pendingPreconditions?.length ?? 0;
  const pendingPreconditionAttributes = step.pendingPreconditionAttributes?.length ?? 0;
  return pendingPreconditions + pendingPreconditionAttributes;
};
